import React, { Fragment } from 'react';
import Modal from 'react-modal';

class modalSpinner extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const { selectedModal, label, contentLabel, tipoSpinner } = this.props;
        const customStyles = {
            content: {
                position: 'fixed', position: 'absolute', top: '35%', left: '40%', right: '40%', bottom: '53%', with: '40%', height: '117px', padding: '5px', 'border-radius': '10px'
                             
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)', 'z-index': '1000'
             
            },

        };


        return (
            <Modal isOpen={selectedModal} contentLabel={contentLabel} style={customStyles} ariaHideApp={false}>
                
                <div className="modal-body">
                    <div className='row'>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div>
                                <div className={`loader${tipoSpinner}`}></div>
                            </div>                         
                        </div>
                       
                    </div>
                </div>
              
            </Modal>
        )



    }
}
export default modalSpinner;